import React, { useState, useEffect } from 'react'
import { BsChevronLeft } from 'react-icons/bs'
import { Helmet } from "react-helmet";
import { BsChevronRight } from 'react-icons/bs'
import StatusBadge from "../../js/buttonstatus.jsx";
import { Cookies } from "../../index.js";
import { RingLoader, BarLoader } from "react-spinners";
import axios from "axios";
import AdSense from 'react-adsense';
const ChangeHistory = () => {
    const [userOption, setUserOption] = useState("changeHistory");
    const [history, sethistory] = useState(false);
    const totalPage = history ? Math.ceil(history.length / 10) : 1;
    const [pageStart, setPageStart] = useState(0)
    const [pageEnd, setPageEnd] = useState(10)
    const handleClick = (pageItem) => {
        setPageStart(0 + pageItem * 10)
        setPageEnd(10 + pageItem * 10)
    }
    const handleClickLeft = () => {
        if (pageStart >= 10) {
            setPageStart(pageStart - 10)
            setPageEnd(pageEnd - 10)
        }
    }
    const lichsudoithe = async () => {
        const apikey = Cookies.get("apikey");
        axios
            .get(
                "https://hust.media/api/wallet/e_commerce/coin_exchange.php?apikey=" + apikey
            )
            .then((response) => {
                console.log(response.data);
                sethistory(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    };
    const handleClickRight = () => {
        if (pageEnd <= history.length) {
            setPageStart(pageStart + 10)
            setPageEnd(pageEnd + 10)
        }
    }
    let intervalId;
    function startLichSuDoiThe() {
        intervalId = setInterval(() => {
            lichsudoithe();
        }, 7000);
    }
    useEffect(() => {
        lichsudoithe();
        startLichSuDoiThe();

        return () => clearInterval(intervalId);
    }, []);
    return (
        <>
            <Helmet>
                <title>Bảng giao dịch Coins hust media</title>
                <meta name="description" content="Bảng giao dịch Coins hust media" />
            </Helmet>
            <div className="max-h-16">
                <div className="cards">
                    <AdSense.Google
                        client="ca-pub-4574266110812955"
                        slot="1627514116"
                        style={{ display: 'block' }}
                        format='horizontal'
                        responsive='false'
                    /></div>
            </div>
            {(userOption === 'changeHistory' && history) ? (
                <div className='mb-3 mt-2 px-2 '>
                    <div className='bg-[#f5f6fa] rounded-md p-1'>
                        <div className='ml-2 border-blue-400 border-b inline'>Bảng niêm yết Coins hust media</div>
                        <div className='overflow-x-scroll lg:overflow-auto '>
                            <table className='w-full'>
                                <tr className='text-xs lg:text-base border-b-2 text-center'>
                                    <td className='text-center'>id</td>
                                    <td className='text-center'>Dịch vụ</td>
                                    <td className='text-center'>Trạng thái</td>
                                    <td className='text-center'>Mệnh giá</td>
                                    <td className='text-center'>Seller</td>
                                    <td className='text-center'>Cost</td>
                                    <td className='text-center'>Time</td>
                                </tr>
                                {history &&
                                    history.slice(pageStart, pageEnd).map((item) => {
                                        return (
                                            <tr className='text-xs border-b-2'>
                                                 <td className='text-center px-2'>{item.id}</td>
                                                <td className='text-center px-2'>{item.service_name}</td>
                                                <td className='text-center px-2'><StatusBadge status={item.status}/><br />{item.type}</td>
                                                <td className='text-center px-2'>{item.api_url}</td>
                                                <td className='text-center px-2'>{item.username}</td>
                                                <td className='text-center px-2'>{item.amount}</td>
                                                <td className='text-center px-2'>{item.createdate}<br />{item.updatedate} </td>
                                            </tr>
                                        )
                                    })}
                            </table>
                        </div>
                        <div className='flex mt-2 justify-center gap-2 flex-wrap'>
                            <div
                                className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer flex items-center text-xs lg:text-base'
                                onClick={() => handleClickLeft()}>
                                <BsChevronLeft />
                            </div>
                            {Array(totalPage)
                                .fill(0)
                                .map((_, index) => {
                                    const pageItem = index + 1
                                    return (
                                        <div
                                            className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer'
                                            onClick={() => handleClick(Number(index))}>
                                            {pageItem}
                                        </div>
                                    )
                                })}
                            <div
                                className='lg:min-w-[34px] text-center text-white px-2 py-1 bg-blue-400 rounded-sm cursor-pointer flex items-center text-xs lg:text-base'
                                onClick={() => handleClickRight()}>
                                <BsChevronRight />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="mt-4 flex justify-center items-center">
                    <BarLoader size={50} color="#003AA5" />{" "}
                </div>
            )}
        </>
    )
}

export default ChangeHistory
